import { LoginSuccess } from '../pages/LoginSuccess';
import CandidatePages from '../pages/candidate';
import LoginPage from '../pages/login';
import SkillPage from '../pages/skill';
import CandidateRolePage from '../pages/candidaterole';
import { LoginFail } from '../pages/LoginFail';
import UsersPage from '../pages/users';
import ReportsPage from '../pages/reports';
//import PrivatePage from '../pages/base/private';

export const
        DEFAULT_PATH = "/",
        HOME_PATH = "/candidates",
        LOGIN_PATH = "/login",
        LOGIN_SUCCESS_PATH = "/login/success",
        CANDIDATES_PATH = "/candidates",
        SKILLS_PATH = "/skills",
        CANDIDATE_ROLES_PATH = "/candidateroles",
        LOGIN_FAIL_PATH = "/login/fail",
        USERS_PATH = "/users",
        REPORTS_PATH = "/reports"
        ;

const routes = [
    {
        path: DEFAULT_PATH, 
        key: DEFAULT_PATH,
        component: LoginPage,
        isPrivate: false,
        exact: true
    },
    {
        path: HOME_PATH,
        key: HOME_PATH,
        component: CandidatePages,
        isPrivate: true,
        exact: true
    },
    {
        path: LOGIN_PATH,
        key: LOGIN_PATH,
        component: LoginPage,
        isPrivate: false,
        exact: true
    },
    {
        path: LOGIN_SUCCESS_PATH,
        key: LOGIN_SUCCESS_PATH,
        component: LoginSuccess,
        isPrivate: false,
        exact: true
    },
    {
      path: LOGIN_FAIL_PATH,
      key: LOGIN_FAIL_PATH,
      component: LoginFail,
      isPrivate: false,
      exact: true
    },
    {
        path: CANDIDATES_PATH,
        key: CANDIDATES_PATH,
        component: CandidatePages,
        isPrivate: true,
        exact: true
    },
    {
        path: SKILLS_PATH,
        key: SKILLS_PATH,
        component: SkillPage,
        isPrivate: true,
      },
      {
        path: CANDIDATE_ROLES_PATH,
        key: CANDIDATE_ROLES_PATH,
        component: CandidateRolePage,
        isPrivate: true,
      },
      {
        path: `${CANDIDATES_PATH}/:id`,
        key: `${CANDIDATES_PATH}/:id`,
        component: CandidatePages,
        isPrivate: false,
        exact: true
      },
      {
        path: `${CANDIDATES_PATH}/:id/edit`,
        key: `${CANDIDATES_PATH}/:id/edit`,
        component: CandidatePages,
        isPrivate: true,
      },
      {
        path: `${USERS_PATH}/`,
        key: `${USERS_PATH}/`,
        component: UsersPage,
        isPrivate: true,
        adminRequired: true
      },
      {
        path: `${REPORTS_PATH}/`,
        key: `${REPORTS_PATH}/`,
        component: ReportsPage,
        isPrivate: true,
        adminRequired: false
      }
]

export default routes;
